import apiClient from './client';
import {TitleWelcomeResponseMessage} from '@/types/TitleWelcomeResponse';

/**
 * Fetches the welcome (home) list of video subjects for the given lingo.
 * Chooses secure or public endpoint based on authentication state.
 * @param titleLingo Language code for content
 * @param secure Whether to use secure (/secure) or public (/public) endpoint
 */
export async function fetchTitleWelcome(
  titleLingo: string,
  secure: boolean = true
): Promise<TitleWelcomeResponseMessage> {
  const prefix = secure ? '/secure/title/welcome' : '/public/title/welcome';
  const response = await apiClient.get<TitleWelcomeResponseMessage>(
      `${prefix}/${encodeURIComponent(titleLingo)}`
  );
  return response.data;
}
